import { useNavigate } from "react-router";

export const ReportReady = () => {
  const navigate = useNavigate();
  return (
    <div className="hero min-h-screen bg-base-200">
      <div className="hero-content flex-col lg:flex-row">
        <img
          alt="livre"
          src="/image/statistic_book.png"
          className=" w-1/2 lg:max-w-sm rounded-lg shadow-2xl"
        />
        <div>
          <h1 className=" text-md lg:text-5xl font-bold">Rapport disponible</h1>
          <p className="py-6">
            Votre rapport est maintenant disponible. Cliquez sur le bouton
            'Accéder au rapport' pour le consulter.
          </p>
          <button
            onClick={() => {
              navigate("/report");
            }}
            className="btn btn-primary"
          >
            Accéder au rapport
          </button>
        </div>
      </div>
    </div>
  );
};
